import { WorkspaceLicense } from "src/app/models/user-licenses.model";
import { ReduxWrapper } from "../app.state";

export class WorkspaceLicensesState {
	licenses!: ReduxWrapper<WorkspaceLicense[]>
}

export const licenseTypeDefaultValue: ReduxWrapper<WorkspaceLicense[]> = { error: undefined, loadedOnce: false, loading: false, value: [] };
export const workspaceLicensesInitialState: WorkspaceLicensesState = { licenses: licenseTypeDefaultValue, };
